import formatDate from 'date-fns/format';
import React, { useMemo } from 'react';
const ForecastSubHeader = ({ forecast }) => {
    const createdAt = useMemo(() => formatDate(forecast.values.createdAt ?? new Date(), 'LLLL do, yyyy'), [forecast.values.createdAt]);
    return (React.createElement("span", null, `${forecast.values.name ?? ''} (${forecast.values.companyName}) - ${createdAt}`));
};
export default ForecastSubHeader;
